import { Component, ChangeDetectionStrategy, inject } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { MatSidenavModule } from '@angular/material/sidenav';
import { Router, RouterOutlet } from '@angular/router';
import { getScreenConfig$ } from './core/screen/config';
import { SidenavComponent } from './core/sidenav/sidenav.component';

@Component({
  imports: [RouterOutlet, MatSidenavModule, SidenavComponent],
  providers: [],
  selector: 'app-root',
  template: `
    <mat-sidenav-container class="h-full w-full">
      <mat-sidenav
        class="h-full"
        mode="side"
        [opened]="screenConfig().hideSidenav !== true"
      >
        <app-sidenav></app-sidenav>
      </mat-sidenav>

      <mat-sidenav-content
        [class.content-wrapper]="screenConfig().hideSidenav !== true"
      >
        <router-outlet></router-outlet>
      </mat-sidenav-content>
    </mat-sidenav-container>
  `,
  styleUrls: ['./app.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AppComponent {
  readonly #router = inject(Router);

  readonly screenConfig = toSignal(getScreenConfig$(this.#router), {
    initialValue: { hideSidenav: true },
  });
}
